<template>
  <div @click="handleClickOutside" class="row mob-view">
    <div class="col-lg-6 col-md-6" style="height: 605px; overflow: auto">
      <ul class="nav nav-pills nav-justified" role="tablist">
        <li @click="loadTreeByType(1)" class="nav-item waves-effect waves-light">
          <a class="nav-link active" data-toggle="tab" href="#cpv-tree" role="tab" aria-selected="true">Ապրանք</a>
        </li>
        <li @click="loadTreeByType(2)" class="nav-item waves-effect waves-light">
          <a class="nav-link" data-toggle="tab" href="#cpv-tree" role="tab" aria-selected="false">Ծառայություն</a>
        </li>
        <li @click="loadTreeByType(3)" class="nav-item waves-effect waves-light">
          <a class="nav-link" data-toggle="tab" href="#cpv-tree" role="tab" aria-selected="false">Աշխատանք</a>
        </li>
      </ul>
      <div id="cpv-tree-containere" class="tab-content py-3">
        <div class="w-100 mb-2">
          <input @input="handleSearch"
                  :value="searchQuery" 
                  class="form-control" 
                  placeholder="Փնտրել" 
                  type="text">
        </div>
        <div class="w-100">
          <vue-tree :selectedOptions="selectedOptions"
                    @select="handleSelect" 
                    @categorySelect="handleSelectCategory" 
                    :loadOptions="loadOptions"
                    :searching="searching" 
                    :loadRootOptions="true" 
                    :node="{children: options}"/>
        </div>
      </div>
    </div>

    <div class="col-lg-6 col-md-6 mob overflow" style="height: 605px;">
      <div class="row">
        <div class="border border-primary position-relative rounded m-1 px-3 py-1 text-primary col-auto mob-width" 
            v-for="cpv in selectedOptions" :key="cpv.id">
          <span class="pr-4" style="white-space: break-spaces;">{{ cpv.code }} - {{ cpv.name }} <small v-if="cpv.used_count" class="font-weight-bold text-dark">(Կազմակերպվել է {{ cpv.used_count }} անգամ)</small></span>
          <font-awesome-icon @click="removeFromOptions(cpv)" 
              icon="times" 
              class="position-absolute"
              style="cursor: pointer; right: 10px; top: calc(50% - 8px);"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueTree from './VueTree'
  export default {
    name: 'CpvSelector',
    components: { VueTree },
    computed: {
      options() {
        return this.searchMode ? this.searchResult : this.cpvTypedObj[this.currentCpvType]
      }
    },
    data() {
      return {
        currentCpvType: 1,
        selectedCpvs: null,
        selectedOptions: [],
        cpvTypedObj: {},
        searchResult: [],
        searchMode: false,
        searchQuery: '',
        searchTimeout: null,
        searching: false,
      }
    },
    watch: {
      selectedOptions: function(updatedOptions) {
        this.$emit('update:selectedCpvs', updatedOptions)
      }
    },
    mounted() {
      this.selectedOptions = this.$attrs.selectedCpvs;
      this.loadTreeByType(1)
    },
    methods: {
      loadOptionsRec(node){
        this.selectedOptions.push(node)
        if(node.parent){
          const isDuplicate = Boolean(this.selectedOptions.find(item => item.id === node.parent.id))
          if(!isDuplicate){
            this.loadOptionsRec(node.parent)
          }
        }
        if(node.children != null){
          node.children.forEach(nodeItem => {
            this.loadOptionsRec(nodeItem)
          });
        } else if(node.children_count){
          this.$store.dispatch('cpv/getById', {id: node.id}).then(cpvItem => {
            if(node.children_count){
              this.$set(node, 'children', cpvItem.children)
              node.children.forEach(nodeItem => {
                this.loadOptionsRec(nodeItem)
              });
            }
          })
        }
      },
      delOptionsRec(node){
        const optionIndex = this.selectedOptions.findIndex(option => option.id === node.id)
        if(optionIndex > 0){
          this.selectedOptions.splice(optionIndex, 1)
          if(node.children){
            node.children.forEach(nodeItem => {
              this.delOptionsRec(nodeItem)
            });
          }
        }
      },
      handleSelectCategory(data) {
        const node = data[0]
        const optionIndex = this.selectedOptions.findIndex(option => option.id === node.id)
        if(optionIndex > -1) {
          this.delOptionsRec(node)
        } else {
          this.loadOptionsRec(node)
        }
      },
      handleSelect(node) {
        const optionIndex = this.selectedOptions.findIndex(option => option.id === node.id)
        if(optionIndex > -1) {
          this.selectedOptions.splice(optionIndex, 1)
        } else {
          // eslint-disable-next-line no-undef
          this.selectedOptions.push(_.cloneDeep(node))
        }
      },
      handleSearch({target: {value}}) {
        this.searchQuery = value
        this.searchResult = []
        if(!this.searchMode) {
          this.searchMode = true
        }        
        if(value.length >= 3) {
          this.searching = true
          if(this.searchTimeout) clearTimeout(this.searchTimeout)
          this.searchTimeout = setTimeout(() => {
            this.$store.dispatch('cpv/search', value).then(({ data: { data } }) => {
              if(data.length) {
                this.searchResult = data
              } else {
                this.searchResult = [{name: 'Արդյունք չի գտնվել!'}]
              }
              this.searching = false
            })
          }, 700)
        } else if(!value.length) {
          this.searchMode = false
          this.searching = false
        }
      },
      handleClickOutside(event) {
        const cpvTreeContainer = document.getElementById('cpv-tree-containere')
        if(!cpvTreeContainer.contains(event.target)) {
          this.clearSearch()
        }
      },
      clearSearch() {
        if(this.searchQuery) this.searchQuery = ''
        if(this.searchResult) this.searchResult = []
        if(this.searchMode) this.searchMode = false
      },
      removeFromOptions(cpv) {
        const index = this.selectedOptions.findIndex(option => option.id === cpv.id)
        if(index > -1) {
          this.selectedOptions.splice(index, 1)
        }
      },
      loadOptions(node) {
        return this.$store.dispatch('cpv/getById', {id: node.id}).then(cpv => {
          return this.$set(node, 'children', cpv.children)
        })
      },
      loadTreeByType(type) {
        if(!this.cpvTypedObj[type]) {
          this.currentCpvType = type
          this.$client.get(`cpv/${this.currentCpvType}`).then(response => {
            // eslint-disable-next-line no-undef
            const cpvTypedObj = _.cloneDeep(this.cpvTypedObj)
            cpvTypedObj[this.currentCpvType] = response.data.data
            this.cpvTypedObj = cpvTypedObj
          })
        } else {
          this.currentCpvType = type
        }
      }
    }
  }
</script>
<style scoped>
  .overflow{
    overflow: auto;
  }
  @media only screen and (max-width: 770px) {
    .mob-view{
      flex-direction: column !important;
    }
    .mob{
      overflow-x: hidden;
      overflow-y: scroll;
    }
    .mob-width{
      width: calc(100% - 8px);
    }
  }
  @media only screen and (max-width: 550px) {
    .mob-width{
      width: calc(100% - 20px);
    }
  }
</style>

